import installer from './defaults'
export * from '@jdesign-vue/components'
export * from '@jdesign-vue/constants'
export * from '@jdesign-vue/directives'
export * from '@jdesign-vue/hooks'
export * from './make-installer'
export { JDesignVueResolver } from './resolver'
export type { JDesignVueResolverOptions } from './resolver'

export const install = installer.install
export const version = installer.version
export default installer

export { default as dayjs } from 'dayjs'
